import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'utcdate'
})
export class UTCDate extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        //value += "Z";
        return super.transform(value, args);
    }
}
